/*eslint-disable */
import Lightbox from 'fslightbox'
/*eslint-enable */

export default {
  init() {
  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateAbout.js